/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_Ref_N6Inputs */

const en_to_typescript_ref_n6 = /** @type {(inputs: To_Typescript_Ref_N6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The element type is unobservable from an empty array, so it falls back to any.`)
};

const ko_to_typescript_ref_n6 = /** @type {(inputs: To_Typescript_Ref_N6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`빈 배열에서는 요소 타입을 관찰할 수 없으므로 any로 물러납니다.`)
};

const ja_to_typescript_ref_n6 = /** @type {(inputs: To_Typescript_Ref_N6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空の配列からは要素型が観測できないので any に退きます。`)
};

/**
* | output |
* | --- |
* | "The element type is unobservable from an empty array, so it falls back to any." |
*
* @param {To_Typescript_Ref_N6Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_ref_n6 = /** @type {((inputs?: To_Typescript_Ref_N6Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_Ref_N6Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_ref_n6(inputs)
	if (locale === "ko") return ko_to_typescript_ref_n6(inputs)
	return ja_to_typescript_ref_n6(inputs)
});